import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { useDispatcher } from '../../../../../store.decorator';
import { EventCentreHookService, Item, ItemAction } from '../../../core';
import { EventCentreDialogService } from '../../event-centre-dialog.service';
import { ViewItem } from '../../model/view-item.model';
import { toggleItemExpand } from '../../state/toggle-item-expand.action';
import { updateItems } from '../../state/update-items.action';

import { TranslationKeyMap } from './card-collection.component.i18n';

@Component({
    selector: 'cmps-event-centre-card-collection',
    templateUrl: './card-collection.component.html',
})
export class CardCollectionComponent {
    @Input()
    items: ViewItem[];

    /** @private */
    _i18n = TranslationKeyMap;

    constructor(
        private readonly _router: Router,
        /** @private */ readonly _service: EventCentreDialogService,
        private readonly _actionHookService: EventCentreHookService,
    ) {}

    /** @private */
    _onToggleExpandClick(item: Item): void {
        useDispatcher(
            this._service,
            toggleItemExpand({
                items: [item],
            }),
        );
    }

    /** @private */
    _onToggleReadClick(item: ViewItem, byExpand?: boolean): void {
        if (byExpand && (item.expanded || item.read)) {
            return;
        }
        useDispatcher(
            this._service,
            updateItems({
                items: [item],
                patch: { read: !item.read, delete: item.deleted },
            }),
        );
    }

    /** @private */
    _onDeleteClick(item: Item): void {
        useDispatcher(
            this._service,
            updateItems({
                items: [item],
                patch: { read: true, delete: true },
            }),
        );
    }

    /** @private */
    _onActionClick(item: Item, action: ItemAction): void {
        let close = false;
        if (action.url != null && action.url.trim().length > 0) {
            void this._router.navigateByUrl(action.url);
            close = true;
        } else {
            const ret1 = this._actionHookService.actionInvoked(item, action);

            const ret2 = this._actionHookService.actionInvoked2(
                item,
                action,
                this._service.state.category,
                this._service,
            );

            if (ret1 && ret2) {
                close = true;
            }
        }

        useDispatcher(
            this._service,
            updateItems({
                items: [item],
                patch: {
                    read: !item.read ? true : item.read,
                    delete: item.deleted,
                },
            }),
        );

        if (close) {
            this._service.close();
        }
    }
}
